module.exports = __webpack_public_path__ + "img/ic_album.718b0463.png";